import {object, string, func} from 'prop-types';
import { Field } from 'react-final-form';
import cn from 'classnames';
import styles from './FormCheckbox.module.scss';

function FormCheckbox(props) {
  const {
    input,
    placeholder,
    meta,
    label,
    onFocus,
    onBlur,
    className,
    value,
    name,
    ...rest
  } = props;

  return (
    <div className={cn(styles.formCheckbox, {
      [styles[className]]: !!className
    })}>
      <input
        id={name + '_' + value}
        {...rest}
        {...input}
      />
      <label
        htmlFor={name + '_' + value}
      >
        {label || value}
      </label>
    </div>
  );
}

FormCheckbox.propTypes = {
  input: object,
  meta: object,
  label: string,
  onBlur: func,
  onFocus: func,
  className: string,
};

FormCheckbox.defaultProps = {
};


const _FormCheckbox = ({ ...rest }) => {
  return (
    <Field component="input" type="checkbox" {...rest}>
      {({ meta, input }) => (
        <FormCheckbox {...rest} meta={meta} input={input} />
      )}
    </Field>
  )
};

export default _FormCheckbox;
